/*
 *
 * BackbookUserNotRegisteredModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 17-Oct-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import { useNavigate } from 'react-router-dom'
import './BackbookUserNotRegisteredModal.scss'

const BackbookUserNotRegisteredModal = (props) => {
  const navigate = useNavigate()

  const redirectToRegistration = () => {
    props.actions.doHidePopup()
    navigate('/registration/vat-email')
  }

  return (
    <Toggle>
      <MerchantModal
        title={formattedMessage.title}
        primaryButtonLabel={formattedMessage.primaryButtonLabel}
        primaryAction={redirectToRegistration}
        onClose={() => props.actions.doHidePopup()}
      >
        {formattedMessage.description}
      </MerchantModal>
    </Toggle>
  )
}

BackbookUserNotRegisteredModal.propTypes = {
  actions: PropTypes.object
}

BackbookUserNotRegisteredModal.defaultProps = {
  actions: {}
}

export default BackbookUserNotRegisteredModal
